import Hero from '../sections/Hero.jsx'
import FeaturedProducts from '../sections/FeaturedProducts.jsx'
import ScienceStrip from '../sections/ScienceStrip.jsx'
import PeptideHallOfFame from '../sections/PeptideHallOfFame.jsx'
import FAQ from '../sections/FAQ.jsx'
import CTA from '../sections/CTA.jsx'
import SEO from '../components/SEO.jsx'
import { pages, applySeoOverrides } from '../config/seo.js'
import { useProducts } from '../context/ProductsContext.jsx'

export default function HomePage() {
  const { seoSettings } = useProducts()
  return (
    <>
      <SEO config={applySeoOverrides(pages.home, seoSettings?.pages?.home)} />
      <Hero />
      <FeaturedProducts />
      <ScienceStrip />
      <PeptideHallOfFame />
      <FAQ />
      <CTA />
    </>
  )
}
